import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[AllowOnlyBracketsInput]'
})
export class AllowOnlyBracketsInputDirective {
   private regex: RegExp = new RegExp(/[!@^&฿*_+={}[\];|:'",<>?é©¥°℃#$%\\]/g);
   private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete', 'Meta', 'Control'];

   constructor(private el: ElementRef) { }

   @HostListener('keydown', ['$event'])
   onKeyDown(event: KeyboardEvent) {
      if ((event.ctrlKey || event.metaKey) &&
        (event.key === 'a' || event.key === 'c' || event.key === 'v' || event.key === 'x')) {
         return;
      }

      if (this.specialKeys.indexOf(event.key) !== -1) {
         return;
      }

      if (event.key.match(this.regex)) {
         event.preventDefault();
      }
   }

   @HostListener('paste', ['$event'])
   onPaste(event: ClipboardEvent) {
      let clipboardData = event.clipboardData;
      let pastedText = clipboardData.getData('text');
      if (pastedText.match(this.regex)) {
         event.preventDefault();
      }
   }
}
